export default "assets/images/icons/close-bold-a7a5a20d.svg";